import optionsModel from './models/options'
import widgetModel from './models/widget'
import dataModel from './models/data'

export default function (_this) {
  return {
    widget: widgetModel(_this),
    options: optionsModel(_this),
    data: dataModel(_this)
  }
}
